
import Enumerable from "linq";
import { Component, Mixins } from "vue-property-decorator";

@Component({
})
export default class TabContainableMixin extends Mixins() {
  data(): any {
    return {
      tabs: [] as { name: string, description: string }[],
      selectedTab: null as { name: string, description: string },
      isTransitioning: false,
    };
  }
  tabs: { name: string, description: string }[];
  selectedTab: { name: string, description: string };
  isTransitioning: boolean;

  get shouldShowAnyTabContent(): boolean {
    return !!this.selectedTab;
  }

  shouldCreateContent(tab: any): boolean {
    return Enumerable.from(this.tabs)
      .any(t => t.name === tab.name);
  }

  shouldShowContent(tab: any): boolean {
    return !!this.selectedTab
      && (this.selectedTab.name === tab.name)
      && !this.isTransitioning;
  }

  clearTabSelection(): void {
    this.selectedTab = null;
  }

  onTransitionBeforeEnter(): void {
    this.isTransitioning = true;
  }

  onTransitionAfterEnter(): void {
    this.isTransitioning = false;
  }

  onTransitionEnterCancelled(): void {
    this.isTransitioning = false;
  }

  onTransitionBeforeLeave(): void {
    this.isTransitioning = true;
  }

  onTransitionAfterLeave(): void {
    this.isTransitioning = false;
  }

  onTransitionLeaveCancelled(): void {
    this.isTransitioning = false;
  }
}
